import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { DialpadDesign } from './components';

// const routes = () => <PrivateRoute exact path="/dashboard" component={AdminDashboard} />;
const DialpadDesign = lazy(()=> import(/* webpackChunkName: "dialpaddesign" */ './components/DialpadDesign'))

const routes = () => [
    <PrivateRoute
        key="DialpadDesign"
        exact
        path="/dialpad-design"
        component={DialpadDesign}
    />
];

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/dialpadDesign/DialpadDesign/routes.js